import { z } from 'zod';

const envSchema = z.object({
  REACT_APP_API_URL: z.string().url().default('http://localhost:4242'),
});

export type Env = z.infer<typeof envSchema>;

function validateEnv(): Env {
  try {
    return envSchema.parse({
      REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    });
  } catch (error) {
    if (error instanceof z.ZodError) {
      console.error('Environment validation failed:', error.issues);
    }
    throw new Error('Invalid environment variables');
  }
}

export const env = validateEnv();
